import { createContext } from "react";
export const Toastcontext=createContext({});//({})قيمه افتراضيه